import BaseModel from "../../core/components/input-widget/BaseModel";

export default class ReportGenerationModel extends BaseModel {
  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
  };

  attributeHints = {};

  attributeLabels = {};
}
